import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketsGridComponent } from './tickets-grid.component';
import { TabModule } from '../tab/tab.module';
import {
  DxButtonModule,
  DxColorBoxModule,
  DxDataGridModule,
  DxLoadPanelModule, DxPopoverModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxSchedulerModule,
  DxScrollViewModule,
  DxBoxModule,
  DxSwitchModule,
  DxFileUploaderModule
} from 'devextreme-angular';
import { GridDefaultModule, GridTitleModule } from 'shared';


@NgModule({
  declarations: [TicketsGridComponent],
  imports: [
    CommonModule,
    TabModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxLoadPanelModule,
    DxSchedulerModule,
    DxPopupModule,
    DxColorBoxModule,
    DxTextAreaModule,
    DxScrollViewModule,
    DxFileUploaderModule,
    DxBoxModule,
    DxButtonModule,
    DxSwitchModule,
    GridTitleModule,
    GridDefaultModule,
    DxPopoverModule
  ],
  exports: [TicketsGridComponent]
})
export class TicketsGridModule { }
